<template>
	<div id="terminal-setup-root" class="terminal-setup-root">
		
		<div class="terminal-wrapper">
			<button @click="logout()" class="btn-logout">Log out</button>
			<div class="img-wrapper">
				<img v-if="design === 'ecruise'" class="logo" src="../../assets/img/eCruise_logo.png" alt="logo">
				<img v-else-if="design === 'margaritaville'" class="logo margaritaville-logo" src="../../assets/img/margaritaville-logo-header.png" alt="logo">
			</div>
			<div class="header">
				<h1>Set up the terminal</h1>
			</div>
			<div class="select-terminal-wrapper">
				
				<div class="set-up-error-wrapper" v-if="step === 1">
					<div class="error-text">The terminal is not set up.</div>
					<div class="error-text">Please inform the manager.</div>
					<button class="def-btn main-action-btn border-2 uppercase" @click="goToDepartments">OK</button>
				</div>
				
				<div class="set-up-terminal-wrapper" v-else-if="step === 2">
					<div class="title">Select Department</div>
					<Dropdown
							ref="depInput"
							:terminalInput="depInput"
							:options="newDepartments"
							:default="'Department'"
							class="select"
							@onItemClick="(e) => this.depInput = e"
							@onInput="setDepartment"
							@searchTerminal="searchTerminal"
							style="z-index: 3"
							:max-height="'200'"
							@click="this.inFocus === 'pos' ? setFocus('pos') : setFocus('department')"
					/>
					
					<div v-if="department">
						<div class="title">POS terminal name</div>
						<Dropdown
								ref="posInput"
								:terminalInput="posInput"
								:options="newTerminalNames"
								:default="'POS Terminal'"
								class="select"
								@onItemClick="(e) => this.posInput = e"
								@onInput="setTerminalName"
								@searchTerminal="searchTerminalName"
								style="z-index: 2"
								@click="setFocus('pos')"
						/>
					</div>
					<button class="def-btn main-action-btn border-2 uppercase" @click="login" v-if="terminalName">
						SET UP
					</button>
				</div>
			</div>
		</div>
		<Keyboard
				class="letters-keypad"
				@clickOnKey="clickOnKey"
				@clear="clear"
				:has-close-btn="false"
				:show-by-default="true"
		/>
	</div>
</template>

<script>
import Dropdown from "@/components/_shared/Dropdown";
import Keyboard from "@/components/_shared/Keyboard";
import {authService} from "@/_api/auth.api";
import store from "@/store";

export default {
	name: 'TerminalSetupRootComponent',
	props: {},
	components: {Keyboard, Dropdown},
	data() {
		return {
			step: 1,
			inFocus: '',
			depInput: '',
			posInput: '',
			posId: null,
			posNameId: null,
			department: '',
			terminalName: null,
			departments: [],
			terminalNames: [],
			newDepartments: [],
			newTerminalNames: []
		}
	},
	computed: {
		design() {
			return this.$store.state.UI
		},
		getUserData() {
			return this.$store.state.auth.user
		},
	},
	created() {
		if (this.getUserData.user.role === 'manager') {
			this.goToDepartments()
		}
	},
	mounted() {
		this.newDepartments = this.departments
		this.newTerminalNames = this.terminalNames
	},
	beforeUnmount() {
	},
	methods: {
		goToDepartments(e) {
			if (this.getUserData.user.role !== 'manager') {
				this.logout()
			} else {
				authService.getDepartments({
					page: 1,
					per_page: 1000,
					
				}).then(res => {
					if (res && res.data) {
						res.data.forEach(el => {
							this.departments.push({name: el.name, id: el.id})
						})
					}
				}).catch(e => {
					throw e
				})
				this.step = 2
			}
		},
		setDepartment(e) {
			this.terminalNames.splice(0, this.terminalNames.length)
			authService.getPoses({
				department_id: e.id
			}).then(res => {
				if (res && res.data) {
					res.data.forEach(el => {
						this.terminalNames.push(el)
					})
				}
			}).catch(error => {
				throw error
			})
			this.department = e;
			this.setFocus('pos');
			console.log(this.inFocus);
		},
		setTerminalName(e) {
			this.posNameId = e.id
			this.department = e
			this.terminalName = e
		},
		searchTerminal(e) {
			this.department = null;
			this.depInput = e;
			this.newDepartments = this.departments.filter(el => el.name.toLowerCase().includes(this.depInput))
		},
		searchTerminalName(e) {
			this.terminalName = null;
			this.posInput = e;
			this.newTerminalNames = this.terminalNames.filter(el => el.name.toLowerCase().includes(this.posInput))
		},
		login() {
			authService.setup({
				id: this.posNameId
			}).then(res => {
				if (res) {
					this.posId = this.posNameId;
					store.dispatch('setupPosId', this.posId);
					// localStorage.setItem('posId', this.posId);
					this.$router.push('/pos');
				}
			}).catch(e => {
				throw e
			})
		},
		logout() {
			this.$store.dispatch('logoutUser').then(() => {
				this.$router.replace({path: '/auth/login'})
			})
		},
		clickOnKey(e) {
			console.log(this.inFocus);
			if (this.inFocus === 'department') {
				this.depInput += e;
				this.newDepartments = this.departments.filter(el => el.name.toLowerCase().includes(this.depInput));
				this.$refs['depInput'].openDD();
			} else if (this.inFocus === 'pos') {
				this.posInput += e;
				this.newTerminalNames = this.terminalNames.filter(el => el.name.toLowerCase().includes(this.posInput));
				this.$refs['posInput'].openDD();
			} else {
				if (this.department) {
					this.inFocus = 'pos';
					this.posInput += e;
					this.newTerminalNames = this.terminalNames.filter(el => el.name.toLowerCase().includes(this.posInput));
					this.$refs['posInput'].openDD();
				} else {
					this.inFocus = 'department';
					this.depInput += e;
					this.newDepartments = this.departments.filter(el => el.name.toLowerCase().includes(this.depInput));
					this.$refs['depInput'].openDD();
				}
			}
		},
		clear() {
			if (this.inFocus === 'department') {
				if (this.depInput.length <= 1) {
					this.depInput = '';
					this.department = null;
					this.posInput = '';
					this.terminalName = null;
				} else {
					this.depInput = this.depInput.slice(0, -1);
				}
				this.newDepartments = this.departments.filter(el => el.name.toLowerCase().includes(this.depInput));
			} else if (this.inFocus === 'pos') {
				this.posInput = this.posInput.slice(0, -1);
				if (this.depInput.length <= 1) {
					this.setFocus('department');
				}
				this.newTerminalNames = this.terminalNames.filter(el => el.name.toLowerCase().includes(this.posInput));
				
			}
		},
		setFocus(type) {
			this.inFocus = type;
		}
	},
	
}
</script>

<style lang="less" scoped>
#terminal-setup-root {
	// position: relative;
	// background: #FFFFFF;
	// box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.12);
	// border-radius: 8px;
	width: 840px;
	// height: 516px;
	margin: 50px auto 0 auto;
	// padding: 24px;
	
	::v-deep(.letters-keypad) {
		left: 0;
		right: 0;
		margin: 0 auto;
		// position: relative;
		&.keypad-type {
			border: none;
			.container {
				box-shadow: none;
				border: none;
				background-color: unset;
				padding: 0;
				width: 100%;
				.keypad {
					margin: 0 auto;
				}
			}
		}
	}
	
	.def-btn {
		width: 100%;
		height: 40px;
	}
	
	.terminal-wrapper {
		position: relative;
		display: block;
		min-height: 470px!important;
		padding: 24px;
		background: #FFFFFF;
		box-shadow: 4px 4px 12px rgb(0 0 0 / 12%);
		border-radius: 8px;
		margin-bottom: 20px;
		
		.img-wrapper {
			.margaritaville-logo {
				padding: 20px 40px;
				// background-color: var(--theme_color);
				border-radius: 10px;
			}
		}
		
		.btn-logout {
			position: absolute;
			right: 10px;
			top: 10px;
			border: none;
			outline: none;
			background: white;
			font-size: 14px;
			line-height: 19px;
			text-align: right;
			text-decoration-line: underline;
			// color: var(--theme_color);
			cursor: pointer;
		}
		
		.header {
			h1 {
				font-weight: normal;
				font-size: 42px;
				line-height: 56px;
				text-align: center;
				// color: var(--theme_color);
			}
		}
		
		.select-terminal-wrapper {
			width: 320px;
			margin: 0 auto;
			
			.set-up-error-wrapper {
				position: relative;
				align-items: center;
				
				.error-text {
					font-weight: 600;
					font-size: 18px;
					line-height: 24px;
					text-align: center;
					color: #1C282D;
					
					&:last-of-type {
						margin-bottom: 40px;
					}
				}
			}
			
			.set-up-terminal-wrapper {
				.title {
					text-align: left;
					font-weight: 600;
					font-size: 14px;
					line-height: 16px;
					color: #1C282D;
					margin: 44px 0 4px 0;
				}
				
				.def-btn {
					margin-top: 40px;
				}
			}
		}
		
		
	}
}

@media (max-width: 1200px) {
	#terminal-setup-root {
		width: 95%;
	}
	
}
@media (max-width: 850px) {
	#keyboard {
		width: 95%;
	}
}
</style>
